module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "overlay",
      "background-color": "white",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]), _vm._v(" "), _c('v-radio-group', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "required": _vm.required,
      "rules": _vm.rules,
      "row": "",
      "dense": ""
    },
    on: {
      "change": _vm.setData
    },
    model: {
      value: (_vm.nota),
      callback: function($$v) {
        _vm.nota = $$v
      },
      expression: "nota"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "0",
      "value": 0
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "1",
      "value": 1
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "2",
      "value": 2
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "3",
      "value": 3
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "4",
      "value": 4
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "6",
      "value": 6
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "7",
      "value": 7
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "8",
      "value": 8
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "9",
      "value": 9
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    }
  })], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "-5px",
      "margin-bottom": "0px"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "50px"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b893462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-selecionar-nota.vue
// module id = 400
// module chunks = 0